export const API_BASE_URL = 'https://svr.pegasus-pms.co.ke/api/';

export const PEGASUS_URLS = {
  login: 'https://pegasus-pms.co.ke',
  signup: 'https://pegasus-pms.co.ke/signup',
};

export const CONTACT_INFO = {
  phone: ['+254712292899', '+254721655268'],
  email: 'mkieru55@gmail.com',
  address: 'Nairobi, Kenya',
};

export const COMPANY_INFO = {
  name: 'ITorama Property Management Agency',
  shortName: 'ITorama',
  founder: 'Mark Kieru',
  tagline: 'Manage your properties like a professional firm — without paying one.',
  description: 'IT-Orama replaces your property agent, your Excel sheets, and your SMS follow-ups with one system. Automated M-Pesa tracking, instant receipts, real-time dashboards — all from your phone.',
};

export const NAV_ITEMS = [
  { id: 'home', label: 'Home' },
  { id: 'why-us', label: 'Features' },
  { id: 'about', label: 'About' },
  { id: 'pricing', label: 'Pricing' },
  { id: 'testimonials', label: 'Testimonials' },
  { id: 'team', label: 'Team' },
  { id: 'contact', label: 'Contact' },
];

export const STATS = [
  { value: '4.67M+', label: 'Kenyan Renters' },
  { value: '60%', label: 'Fewer Late Payments' },
  { value: 'KES 276K+', label: 'Saved Per Year' },
  { value: '92.8%', label: 'M-Pesa Penetration' },
];

export const WHY_US_FEATURES = [
  {
    id: 1,
    title: 'Automated M-Pesa Reconciliation',
    description: 'Payments are matched to tenants automatically. No more checking M-Pesa statements line by line.',
    icon: 'AccountBalanceWallet',
  },
  {
    id: 2,
    title: 'Instant Receipts & Billing',
    description: 'Send rent invoices and receipts to all tenants with one click via SMS or WhatsApp.',
    icon: 'Receipt',
  },
  {
    id: 3,
    title: 'Full Accounting Suite',
    description: 'Income, expenses, and owner statements generated automatically. Know your numbers instantly.',
    icon: 'Assessment',
  },
  {
    id: 4,
    title: 'Digital Lease Agreements',
    description: 'Create, send, and store lease agreements digitally. No more lost paperwork.',
    icon: 'Description',
  },
  {
    id: 5,
    title: 'WhatsApp & SMS Integration',
    description: 'Communicate with tenants through the channels they already use. Automated reminders included.',
    icon: 'Chat',
  },
  {
    id: 6,
    title: 'Staff & Sub-User Management',
    description: 'Add caretakers, accountants, or co-owners with role-based access to your properties.',
    icon: 'SupervisorAccount',
  },
];

export const PRICING_TIERS = [
  {
    id: 'starter',
    name: 'Starter',
    price: 0,
    priceLabel: 'Free',
    unitLimit: 'Up to 5 units',
    popular: false,
    features: [
      'M-Pesa reconciliation',
      'Tenant SMS receipts',
      'Basic reporting',
      'Single user',
    ],
    cta: 'Get Started Free',
  },
  {
    id: 'professional',
    name: 'Professional',
    price: 3500,
    priceLabel: 'KES 3,500/mo',
    unitLimit: 'Up to 20 units',
    popular: true,
    features: [
      'Everything in Starter',
      'Full accounting suite',
      'WhatsApp integration',
      'Digital lease agreements',
      'Up to 3 users',
    ],
    cta: 'Start Free Trial',
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 5000,
    priceLabel: 'KES 5,000/mo',
    unitLimit: 'Unlimited units',
    popular: false,
    features: [
      'Everything in Business',
      'Dedicated account manager',
      'API access',
      'Unlimited users',
      'SLA guarantee',
    ],
    cta: 'Contact Sales',
  },
];

export const AGENT_COMPARISON = {
  agentFeePercent: 10,
  defaultUnits: 10,
  defaultRent: 25000,
  tiers: [
    { maxUnits: 5, monthlyCost: 0 },
    { maxUnits: 25, monthlyCost: 2000 },
    { maxUnits: 75, monthlyCost: 3500 },
    { maxUnits: Infinity, monthlyCost: 5000 },
  ],
};

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'James Mwangi',
    role: 'Landlord, 12 Units — South B',
    avatar: null,
    rating: 5,
    quote: 'I manage 12 units in South B. I used to spend every 5th of the month calling tenants. Now I open IT-Orama, click \'Bill Tenants\', and everyone gets an SMS. M-Pesa payments match automatically. It changed everything.',
  },
  {
    id: 2,
    name: 'Sarah Wanjiku',
    role: 'Property Investor — Kiambu',
    avatar: null,
    rating: 5,
    quote: 'I was paying my agent KES 25,000/month. Switched to IT-Orama and saved KES 276,000 in my first year. I now manage 20 units myself from my phone — it\'s easier than I expected.',
  },
  {
    id: 3,
    name: 'Peter Ochieng',
    role: 'Real Estate Developer — Kisumu',
    avatar: null,
    rating: 5,
    quote: 'The accounting reports alone are worth it. I used to dread tax season because my records were scattered across WhatsApp and notebooks. Now I export a clean P&L in seconds.',
  },
  {
    id: 4,
    name: 'Grace Njeri',
    role: 'Landlord, 8 Units — Ruaka',
    avatar: null,
    rating: 5,
    quote: 'My tenants love getting instant receipts via SMS after paying. Fewer disputes, fewer calls. I wish I had started using IT-Orama years ago.',
  },
];

export const TEAM_MEMBERS = [
  {
    id: 1,
    name: 'Mark Kieru',
    role: 'Founder & CEO',
    bio: 'A seasoned real estate professional with a passion for delivering exceptional property management services.',
    avatar: null,
    social: {
      email: 'mkieru55@gmail.com',
      linkedin: null,
    },
  },
  {
    id: 2,
    name: 'Juliana Wanjiku',
    role: 'Operations Manager',
    bio: 'Ensures smooth day-to-day operations and maintains high service standards across all managed properties.',
    avatar: null,
    social: {
      email: null,
      linkedin: null,
    },
  },
  {
    id: 3,
    name: 'Kharbie',
    role: 'Property Coordinator',
    bio: 'Expert in tenant relations and property maintenance coordination with keen attention to detail.',
    avatar: null,
    social: {
      email: null,
      linkedin: null,
    },
  },
  {
    id: 4,
    name: 'Cindy Wanjiru',
    role: 'Finance & Accounts',
    bio: 'Handles all financial reporting and ensures accurate, timely rent collection and disbursement.',
    avatar: null,
    social: {
      email: null,
      linkedin: null,
    },
  },
];

export const SOCIAL_LINKS = {
  facebook: null,
  twitter: null,
  instagram: null,
  linkedin: null,
};
